import { USER_NAME_MAX_LENGTH, USER_NAME_REGEX } from "@saleshub/schemas/users";
import * as yup from "yup";

// Mapper for displaying MIME types in understandable names
const FILE_MIME_TYPE_LABELS = {
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "image/jpg": "JPG",
  "image/svg+xml": "SVG",
} as const;

type MimeTypeKey = keyof typeof FILE_MIME_TYPE_LABELS;

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

/**
 * Yup test for file size validation
 * @param allowedTypes - array of allowed MIME types (optional)
 */
export function fileSizeYupTest(allowedTypes?: MimeTypeKey[]) {
  return yup
    .mixed()
    .nullable()
    .test("file-or-url", "You must provide a valid file or a valid URL", function (value) {
      if (!value) return true;

      if (value instanceof File) {
        if (allowedTypes && !allowedTypes.includes(value.type as MimeTypeKey)) {
          const allowedLabels = allowedTypes.map((type) => FILE_MIME_TYPE_LABELS[type] || type).join(", ");
          return this.createError({ message: `Only ${allowedLabels} files are allowed` });
        }

        if (value.size > MAX_FILE_SIZE) {
          return this.createError({ message: `File size must be less than ${MAX_FILE_SIZE / 1024 / 1024}MB` });
        }

        return true;
      } else if (typeof value === "string") {
        return yup.string().url().isValidSync(value) && value.trim() !== "";
      }

      return false;
    });
}

export const nameValidationSchema = yup
  .string()
  .max(USER_NAME_MAX_LENGTH, "Name is too long")
  .required("Name is required")
  .matches(USER_NAME_REGEX, "Name cannot contain numbers or special characters");
